
import { formatDate } from '../../../shared/utils';
import PillLabel from './PillLabel';

/**
 * 
 * @param {object} props 
 * @param {Date|string|number} props.value
 * @param {boolean} props.dateOnly
 * @param {string} props.className
 * @returns 
 */
export default function DateTime(props) {

   const [ date, time ] = formatDate(props.value, { time: true }).split(' @ ');

   return <PillLabel className={props.className}>
      <div className="inline-flex gap-1">
         {date}
         {!props.dateOnly && <>
            <span className="font-bold">@</span>
            <span> {time}</span>
         </>}
      </div>
   </PillLabel>
}